module.exports = __webpack_public_path__ + "img/item14.b5aea432.png";